<template>
  <div v-show="showLogin">
    <Head :title="__('Log In')" />
    <form @submit.prevent="attempt" class="bg-white dark:bg-gray-800 shadow rounded-lg p-8 max-w-[25rem] mx-auto">
      <div class="mb-6">
        <label class="block mb-2" for="email">{{ __('Email Address') }}</label>
        <input v-model="form_login.email" class="form-control form-input form-input-bordered w-full"
          :class="{ 'form-input-border-error': form_login.errors.has('email') }" id="email" type="email" name="email"
          autofocus="" required />
        <HelpText class="mt-2 text-red-500" v-if="form_login.errors.has('email')">
          {{ form_login.errors.first('email') }}
        </HelpText>
      </div>
      <div class="mb-6">
        <label class="block mb-2" for="password">{{ __('Password') }}</label>
        <input v-model="form_login.password" class="form-control form-input form-input-bordered w-full"
          :class="{ 'form-input-border-error': form_login.errors.has('password') }" id="password" type="password"
          name="password" required />
        <HelpText class="mt-2 text-red-500" v-if="form_login.errors.has('password')">
          {{ form_login.errors.first('password') }}
        </HelpText>
      </div>
      <div class="flex mb-6">
        <CheckboxWithLabel :checked="form_login.remember" @input="() => (form_login.remember = !form_login.remember)">
          {{ __('Remember me') }}
        </CheckboxWithLabel>
      </div>
      <DefaultButton class="w-full flex justify-center" type="submit">
        <span>
          {{ __('Log In') }}
        </span>
      </DefaultButton>
      <a :href="$url('/recuperar-clave/m/in')" class="block mt-2.5 mx-0 mb-0 text-gray-500 font-bold text-center">
        <span>{{ __('Forgot your password?') }}</span>
      </a>
      <a @click="showRegister" class="block mt-2.5 mx-0 mb-0 text-gray-500 font-bold text-center cursor-pointer">
        <span>{{ __('¿Listo para unirte? Regístrate ahora mismo.') }}</span>
      </a>
    </form>
    <a href="https://recibopagos.com/" class="block relative mx-auto mt-8 mb-0 w-fit text-gray-500 font-bold">
      <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='currentColor' width='24'
        height='24' class="absolute left-0 top-1/2 -translate-y-2/4">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
      </svg>
      <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='currentColor' width='24'
        height='24' class="absolute left-0 top-1/2 -translate-y-2/4">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
      </svg>
      <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='currentColor' width='24'
        height='24' class="absolute left-0 top-1/2 -translate-y-2/4">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
      </svg>
      <span class="ml-7 text-base">Volver a recibopagos.com</span>
    </a>
  </div>
  <div v-show="showModal">
    <!-- <Head :title="__('Seleccione Comercio')"/> -->
    <div class="bg-white dark:bg-gray-800 shadow rounded-lg p-8 max-w-[25rem] mx-auto">
      <h1 class="font-normal text-xl md:text-xl mb-3 flex items-center"><span>Seleccione Comercio</span></h1>
      <div class="mb-6 mt-4">
        <label class="block mb-2" for="email">{{ __('Comercios') }}</label>
        <select v-model="form_merchant.id" name="merchant"
          class="w-full block form-control form-control-bordered form-input">
          <option selected disabled value="">- Seleccione - </option>
          <option v-for="merchant in merchants" :key="merchant.id" :value="merchant.id">{{ merchant.company_name }}
          </option>
        </select>
        <HelpText class="mt-2 text-gray-500">
          Seleccione el comercio con el cual desea operar en la plataforma.
        </HelpText>
      </div>
      <DefaultButton class="w-full flex justify-center" @click="setMerchant">
        <span>
          {{ __('Confirmar') }}
        </span>
      </DefaultButton>
    </div>
  </div>
  <div v-if="showOnboarding">
    <Onboarding/>
  </div>
</template>

<script>
import Auth from '@/layouts/Auth'
import axios from 'axios';
import Onboarding from '@/components/Onboarding'

export default {
  name: 'LoginPage',
  layout: Auth,
  props: {
    onboarding: String, // Define el tipo de la propiedad
  },
  data: () => ({
    form_login: Nova.form({
      email: '',
      password: '',
      remember: false,
    }),
    form_merchant: {
      id: ''
    },
    showLogin: true,
    showModal: false,
    showOnboarding: false,
    path: '/',
    merchants: [],
    buttonBack: 'Regresar a Inicio de sesión.'
  }),
  methods: {
    async attempt() {
      try {
        const { redirect, merchants } = await this.form_login.post(Nova.url('/login'))
        if (redirect !== undefined && redirect !== null) {
          this.path = { url: redirect, remote: true }
          if (merchants.length > 1) {
            this.merchants = merchants
            this.showLogin = false
            this.showModal = true
          } else {
            Nova.visit(this.path)
          }
        }
      } catch (error) {
        if (error.response?.status === 500) {
          Nova.error(this.__('There was a problem submitting the form.'))
        }
      }
    },
    async setMerchant() {
      try {
        if (this.form_merchant.id == '') {
          Nova.error('Debe seleccionar un Comercio.')
        } else {
          const response = await axios.post(Nova.url('/merchant/set'), {
            id: this.form_merchant.id
          })

          if (response.data.status == 'ok') {
            Nova.visit(this.path)
          } else {
            Nova.error('Error al seleccionar Comercio.')
          }
        }
      } catch (error) {
        if (error.response?.status === 500) {
          Nova.error(this.__('There was a problem submitting the form.'))
        }
      }
    },
    async showRegister() {
      this.showLogin = false
      this.showModal = false
      this.showOnboarding = true
    },
  },
  computed: {
  },
  mounted() {
    if (this.onboarding == 'onboarding') {
      this.buttonBack = 'Ir a inicio de sesión'
      this.showRegister()
    }
  },
}
</script>
<style>
label .checkbox {
  margin-right: 5px
}
</style>